import { UIHeading5, UIText2 } from '@cian/ui-kit/typography';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './Rating.css';
import { StarIcon } from '../../../../../common/components/Icons';
import { IDailyRentOfferForMobileSite } from '../../../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

interface IRatingProps {
  className?: string;
  offer: Pick<IDailyRentOfferForMobileSite, 'rating' | 'reviewsCount'>;
}

export const getReviewsNumber = (reviewsCount?: string | null) => {
  return reviewsCount ? parseInt(reviewsCount.replace(/^\D+/g, ''), 10) : 0;
};

export const Rating = (props: IRatingProps) => {
  const {
    className,
    offer: { rating, reviewsCount },
  } = props;

  const reviewsCountNumber = getReviewsNumber(reviewsCount);

  const hasRating = rating && rating.length > 0;
  const hasReviewsCount = reviewsCountNumber > 0;

  if (!hasRating && !hasReviewsCount) {
    return (
      <div data-testid="RatingComponent" className={cn(styles['root'], className)}>
        <div className={styles['rating']}>
          <StarIcon color="var(--icon-primary-disabled)" />
        </div>
        <UIText2 data-testid="RatingComponent_empty" color="text-secondary-default">
          Нет отзывов
        </UIText2>
      </div>
    );
  }

  if (hasRating && !hasReviewsCount) {
    return (
      <div data-testid="RatingComponent" className={cn(styles['root'], className)}>
        <div className={styles['rating']}>
          <StarIcon />{' '}
          <UIHeading5 data-testid="RatingComponent_rating" color="decorative-orange">
            {rating}
          </UIHeading5>
        </div>
      </div>
    );
  }

  if (!hasRating && hasReviewsCount) {
    return (
      <div data-testid="RatingComponent" className={cn(styles['root'], className)}>
        <StarIcon />
        <UIText2 data-testid="RatingComponent_reviews" color="text-secondary-default">
          {reviewsCount}
        </UIText2>
      </div>
    );
  }

  return (
    <div data-testid="RatingComponent" className={cn(styles['root'], className)}>
      <div className={styles['rating']}>
        <StarIcon />{' '}
        <UIHeading5 data-testid="RatingComponent_rating" color="decorative-orange">
          {rating}
        </UIHeading5>
      </div>
      <UIText2 data-testid="RatingComponent_reviews" color="text-secondary-default">
        {reviewsCount}
      </UIText2>
    </div>
  );
};
